import hags from "../../assets/hags.png";
import playtop from "../../assets/playtop.png";
import berliner from "../../assets/berliner.png";
import novum from "../../assets/novum.png";
import playtopNike from "../../assets/playtop-nike.png";
import jumpingPillows from "../../assets/jumping-pillows-logo.png";
import nordicLawn from "../../assets/nordic-lawn-logo.png";
import kdf from "../../assets/kdf-logo.png";
import eurotramp from "../../assets/eurotramp-logo.png";
import rubrig from "../../assets/rubrig.webp";
import starmax from "../../assets/starmax-logo.png";
import denfit from "../../assets/denfit-logo.png";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";

const partnersData = [
  { img: hags, desc: "Hags", path: "https://www.hags.com/" },
  {
    img: berliner,
    desc: "Berliner",
    path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
  },
  { img: novum, desc: "Novum", path: "https://novum4kids.com/" },
  { img: playtop, desc: "Playtop", path: "https://www.playtop.com/" },
  { img: kdf, desc: "KDF", path: "https://www.kdf.gr/en/" },
  {
    img: playtopNike,
    desc: "Playtop with nike grind",
    path: "https://www.playtop.com/products/playtop-with-nike-grind",
  },
  {
    img: jumpingPillows,
    desc: "Jumping Pillows",
    path: "https://originaljumpingpillows.com/",
  },

  {
    img: eurotramp,
    desc: "Eurotramp Trampoline",
    path: "https://www.eurotramp.com/en/",
  },
  {
    img: nordicLawn,
    desc: "Nordic Lawn",
    path: "https://nordiclawn.com/da/",
  },
  {
    img: denfit,
    desc: "DENFIT",
    path: "https://denfit.nl",
  },
  {
    img: starmax,
    desc: "STARMAX",
    path: "https://starmax.com.pl/",
  },
  {
    img: rubrig,
    desc: "RUBRIG",
    path: "https://rubrig.com/",
  },
];
const Partners = () => {
  const { t } = useTranslation();
  return (
    <section className="relative w-full h-full px-[5%]">
      <div className="flex flex-col items-center justify-between w-full gap-12 py-16 md:flex-row md:py-20 maxContainer">
        <div className="flex flex-col md:w-3/5">
          <h2 className="mt-2 mb-5 font-bold leading-tight text-[28px] ss:text-md md:text-lg md:max-w-[599px] ">
            {t("partnerTranslate.heading")}
          </h2>

          <p className="mb-5 text-base text-greyText ">
            {t("partnerTranslate.desc1")}
            <br />
            <br />
            <Trans
              i18nKey="partnerTranslate.desc2"
              components={{
                1: (
                  <a
                    href="https://www.hags.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary underline"
                  >
                    Hags
                  </a>
                ),
                2: (
                  <a
                    href="https://www.novumedukacja.pl"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary underline"
                  >
                    Novum
                  </a>
                ),
                3: (
                  <a
                    href="https://www.berliner-seilfabrik.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary underline"
                  >
                    Berliner
                  </a>
                ),
              }}
            />
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-y-8 gap-x-12 md:w-1/2 h-max">
          {partnersData.map(({ img, desc, path }, idx) => (
            <Link
              target="_blank"
              to={path}
              className="relative w-full max-w-[114px] transition-transform duration-300 transform hover:scale-105 rounded-lg"
              key={idx}
            >
              <img
                src={img}
                alt={desc}
                className="object-contain w-full h-full"
              />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
